module.exports = __webpack_public_path__ + "static/img/sanctionLogo.bc4091de.png";